export const BRAND_KIT_INITIAL_COLOR = '#ffffff';

export const BRAND_KIT_ACCEPT_FORMATS = {
  fonts: '.otf,.ttf',
  background: '.jpeg,.png,.jpg',
  introOutro: '.mp4,.mov'
};

export const BRAND_KIT_MAX_FILES = 10;
export const BRAND_KIT_MAX_FILE_SIZE = 50; // max size set to 50MB

export const FONT_VALIDATION_ERROR_TTF = 'This file might be corrupted, please update the file and try again.';
export const FONT_VALIDATION_ERROR_OTF =
  'This font isn’t supported. Convert your font to TTF and upload again. If it’s still not working, the file might be corrupted.';

export const MEDIA_PICKER_TABS = [
  { id: 'uploads', label: 'Uploads' },
  { id: 'brandkit', label: 'Brand Kit' }
] as const;
